// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for emoji images */
.emoji-image {
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center;
    transition: filter 0.5s ease;
    width: 6rem;
    height: 4rem;
  }
  
  .emoji-image:hover {
    filter: none;
  }
  
  .emoji-image.active {
    filter: none !important;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .emoji-image {
      width: 5rem;
      height: 3.5rem;
    }
  
    .emoji-section {
      margin-bottom: 1rem;
    }
  
    .text-center.text-xs {
      font-size: 0.75rem;
    }
  }
  
  @media (max-width: 480px) {

    body{
        background-color: #ffff;
    }

    .emoji-image {
      width: 60px;
      height: 3rem;
    }
  
    .emoji-section {
      margin: 0%;
      padding: 0;
    }
  
    .text-center.text-xs {
      font-size: 0.6rem;
    }
  
    .emoji-box {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
    }
  
    .emoji-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: auto;
      margin: 0.5rem;
    }

    @media (max-width: 330px) {
        .emoji-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: auto;
            margin: 0rem;
          }

          .emoji-image {
            width: 50px;
            height: 3rem;
          }
        
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/emoji-box/style.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA,sBAAsB;EACtB;IACE;MACE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;;IAEE;QACI,uBAAuB;IAC3B;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,UAAU;MACV,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;MACX,cAAc;IAChB;;IAEA;QACI;YACI,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,WAAW;YACX,YAAY;UACd;;UAEA;YACE,WAAW;YACX,YAAY;UACd;;IAEN;EACF","sourcesContent":["/* Base styles for emoji images */\n.emoji-image {\n    background-size: 70%;\n    background-repeat: no-repeat;\n    background-position: center;\n    transition: filter 0.5s ease;\n    width: 6rem;\n    height: 4rem;\n  }\n  \n  .emoji-image:hover {\n    filter: none;\n  }\n  \n  .emoji-image.active {\n    filter: none !important;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .emoji-image {\n      width: 5rem;\n      height: 3.5rem;\n    }\n  \n    .emoji-section {\n      margin-bottom: 1rem;\n    }\n  \n    .text-center.text-xs {\n      font-size: 0.75rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n\n    body{\n        background-color: #ffff;\n    }\n\n    .emoji-image {\n      width: 60px;\n      height: 3rem;\n    }\n  \n    .emoji-section {\n      margin: 0%;\n      padding: 0;\n    }\n  \n    .text-center.text-xs {\n      font-size: 0.6rem;\n    }\n  \n    .emoji-box {\n      display: flex;\n      flex-wrap: nowrap;\n      justify-content: center;\n    }\n  \n    .emoji-section {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: auto;\n      margin: 0.5rem;\n    }\n\n    @media (max-width: 330px) {\n        .emoji-section {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: auto;\n            margin: 0rem;\n          }\n\n          .emoji-image {\n            width: 50px;\n            height: 3rem;\n          }\n        \n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
